import React from 'react';

import { useTranslate } from '@src/core/hooks';
import { type Transactable } from '@src/domains/transactables';

import { PixCodeBlock } from './PixCodeBlock';
import { PixExpiredAlert } from './PixExpiredAlert';
import { PixHowToList } from './PixHowToList';
import {
  ChangeMethodButton,
  PixCardDescription,
  PixCardHeader,
  PixCardRoot,
  PixCardTitle,
  PixCardTitleGroup,
} from './styles';
import { usePixPaymentCard } from '../hooks/usePixPaymentCard';

type PixPaymentCardProps = {
  transactable: Transactable;
  onChangeMethod: () => void;
};

export const PixPaymentCard = (props: PixPaymentCardProps) => {
  const { transactable, onChangeMethod } = props;
  const { i18n } = useTranslate();

  const { isExpired, pix, secondsRemaining, timerSize, onTimerRanOut, orderId, changeMethodLabel } =
    usePixPaymentCard(transactable);

  return (
    <PixCardRoot data-testid='pix-payment-card'>
      <PixCardHeader>
        <ChangeMethodButton variant='outlined' color='neutral' onClick={onChangeMethod}>
          {changeMethodLabel}
        </ChangeMethodButton>

        <PixCardTitleGroup>
          <PixCardTitle>{i18n('checkout_payment_pix_title')}</PixCardTitle>
          <PixCardDescription>{i18n('checkout_payment_pix_description')}</PixCardDescription>
        </PixCardTitleGroup>
      </PixCardHeader>

      {isExpired ? (
        <PixExpiredAlert orderId={orderId} />
      ) : pix ? (
        <PixCodeBlock
          code={pix.code}
          qrCode={pix.qrCode}
          secondsRemaining={secondsRemaining}
          timerSize={timerSize}
          onTimerRanOut={onTimerRanOut}
        />
      ) : null}

      <PixHowToList flush={isExpired} />
    </PixCardRoot>
  );
};

export default PixPaymentCard;
